<template>
  <div v-if="true" :class="['app-wrapper', 'landing', theme]">
    <h1 ref="title">{{ config.title }}</h1>
  </div>
  <div v-else :class="['app-wrapper', theme]">
    <div class="o-header">
      <div
        v-if="config.headerVideoId"
        class="mychannels"
        data-mychannels-type="video"
        data-mychannels-options="FUFFU_default"
        :data-mychannels-id="config.headerVideoId"
        style="min-width: 100%; aspect-ratio: 16/9"
      />
      <img v-if="config.headerImage" :src="config.headerImage" />

      <SoundValue />

      <p class="o-header__copy">
        {{ $t('campaign.description') }}
        <br />
        <a @click.prevent="openCampaignPageLink"> {{ $t('campaignPage.linkCopy') }} </a>
      </p>

      <SignupMoment />

      <div v-if="config.campaignEnded && config.campaignEndedLink" class="o-more-info">
        <button @click="openCampaignEndPageLink">{{ $t('campaignEndPage.linkCopy') }}</button>
      </div>

      <div v-if="config.sponsorLink" class="o-more-info">
        <SponsorBanner />
      </div>

      <div v-if="config.sound && !config.campaignEnded" class="o-sound">
        <h2>{{ $t('soundListener.title') }}</h2>
        <p>
          {{ $t('soundListener.description') }}
        </p>
        <AudioPlayer :sound="config.sound" />
      </div>
    </div>

    <WrongAnswers />

    <div class="o-more-info">
      <button @click="openCampaignPageLink">{{ $t('campaignPage.linkCopy') }}</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'pinia'
import WrongAnswers from './components/WrongAnswers.vue'
import SoundValue from './components/SoundValue.vue'
import SignupMoment from './components/SignupMoment.vue'
import SponsorBanner from './components/SponsorBanner.vue'
import { useSignupStore } from './store/signup'
import { useSocketStore } from './store/socket'
import { hybrid, openLink } from '@dpgradio/creative'
import { CAMPAIGN_CONFIG } from './utils/config'
import AudioPlayer from './components/AudioPlayer/AudioPlayer.vue'

export default {
  name: 'App',
  components: {
    WrongAnswers,
    AudioPlayer,
    SoundValue,
    SignupMoment,
    SponsorBanner,
  },
  data() {
    return {
      config: null,
    }
  },
  computed: {
    theme() {
      return this.config.theme
    },
    isCampaignEnded() {
      return this.config.campaignEnded ?? false
    },
  },
  created() {
    this.config = CAMPAIGN_CONFIG
  },
  async mounted() {
    this.fetchCurrentValue()
    if (this.config.type === 'sockets') {
      this.subscribeToSocket(this.config.stationId)
    } else {
      await this.fetchSignUpMoment()
    }
  },
  methods: {
    ...mapActions(useSignupStore, ['fetchSignUpMoment', 'fetchCurrentValue']),
    ...mapActions(useSocketStore, ['subscribeToSocket']),
    openCampaignPageLink() {
      if (hybrid.isNativeApp()) {
        hybrid.call('navigateTo', { url: this.config.campaignPageLink, inApp: true })
      } else {
        openLink(this.config.campaignPageLink)
      }
    },
    openCampaignEndPageLink() {
      if (hybrid.isNativeApp()) {
        hybrid.call('navigateTo', { url: this.config.campaignEndedLink, inApp: true })
      } else {
        openLink(this.config.campaignEndedLink)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.landing {
  background: blue;
  font-family: var(--font-body);
  display: grid;
  place-items: center;
}

.landing h1 {
  font-family: var(--font-title);
  text-align: center;
  font-size: 10vw;
  color: black;
  text-shadow:
    -1px -1px 0 white,
    1px -1px 0 white,
    -1px 1px 0 white,
    1px 1px 0 white,
    0 0 4px rgba(255, 0, 0, 0.3),
    0 0 8px rgba(255, 0, 0, 0.15),
    0 0 16px rgba(255, 0, 0, 0.08);
}
.app-wrapper {
  background: white;
  min-height: 100vh;
  margin: 0;
  font-family: var(--font-body);
  color: rgb(var(--secondary-color));
}

h1,
h2,
h3 {
  font-family: var(--font-title);
  letter-spacing: var(--letter-spacing-title);
  text-transform: var(--title-text-transform);
  margin: 10px 0;
  font-weight: 100;
}

p {
  font-family: var(--font-body);
}

.o-title {
  &--centered {
    text-align: center;
  }
}

input,
button {
  box-sizing: border-box;
  -webkit-appearance: none;
  border-radius: 0;
}

input {
  display: block;
  width: 100%;
  font-family: var(--font-body);
  font-size: 16px;
  padding: 12px;
  border: 0;
}

button {
  font-family: var(--font-title);
  letter-spacing: var(--letter-spacing-title);
  text-transform: var(--title-text-transform);
  background-color: white;
  color: rgb(var(--secondary-color));
  width: 100%;
  padding: 8px;
  font-size: 20px;
  font-weight: 600;
  border: 0;

  &:disabled {
    opacity: 0.5;
  }
}

a {
  color: rgb(var(--primary-color));
}

.o-info-loading {
  background-color: rgb(var(--secondary-color));
  padding: 20px;
  color: white;
  text-align: center;
}

.o-header {
  img {
    width: 100%;
    display: block;
    height: auto;
  }

  &__copy {
    padding: 0 20px;
    white-space: pre-line;
  }
}

.o-more-info {
  padding: 20px;

  button {
    color: white;
    background-color: rgb(var(--primary-color));
  }
}

.o-sound {
  padding: 20px;
  color: rgb(var(--secondary-color));
}
</style>
